<template>
  <div>
    <Modal
      v-model="show"
      :title="type == 'add' ?$t('add'):$t('edit')"
      :mask-closable="false"
      width="800"
      @on-cancel="cancel"
    >
      <div class="modal">
        <Form ref="form" :model="form" :rules="ruleInline" inline :label-width="120" label-colon>
          <Tabs :value="tabs" @on-click="ontabs" :animated="false">
            <TabPane :label="$t('Langue.zn')" name="1">
              <div class="tabs_item">
                <FormItem class="item_input" prop="zh-cn_cname" :label="$t('Role.name')">
                  <Input type="text" v-model="form['zh-cn_cname']" placeholder="请输入平台角色名字"></Input>
                </FormItem>
              </div>
            </TabPane>
            <TabPane :label="$t('Langue.tw')" name="2">
              <div class="tabs_item">
                <FormItem class="item_input" prop="zh-tw_cname" :label="$t('Role.name')">
                  <Input type="text" v-model="form['zh-tw_cname']" placeholder="請輸入平臺角色名字"></Input>
                </FormItem>
              </div>
            </TabPane>
            <TabPane :label="$t('Langue.en')" name="3">
              <div class="tabs_item">
                <FormItem class="item_input" prop="en_cname" :label="$t('Role.name')">
                  <Input
                    type="text"
                    v-model="form.en_cname"
                    placeholder="Please enter the platform role name"
                  ></Input>
                </FormItem>
              </div>
            </TabPane>
          </Tabs>
          <div class="item">
            <FormItem prop="sort_id" :label="$t('sort')">
              <InputNumber
                :min="1"
                v-model="form.sort_id"
                :placeholder="tabs == 1 ? '请输入排序顺序':tabs == 2 ? '請輸入排序順序':'Please enter the sort order'"
              ></InputNumber>
            </FormItem>
            <FormItem :label="$t('role')" prop="role">
              <Select
                v-model="form.role"
                :placeholder="tabs == 1 ? '请选择角色':tabs == 2 ? '請選擇角色':'Please select a role'"
                class="input"
              >
                <Option
                  v-for="(item,index) in roleList"
                  :value="item.key"
                  :key="index"
                >{{ item.value }}</Option>
              </Select>
            </FormItem>
            <FormItem :label="$t('img_lnk')" prop="reg_image">
              <Upload
                ref="upload"
                :show-upload-list="false"
                :before-upload="handleBeforeUpload"
                type="drag"
                action
                style="display: inline-block;width:150px;height: 150px;"
              >
                <div class="demo-upload-list" v-if="form.reg_image != ''">
                  <template>
                    <img :src="form.reg_image" />
                  </template>
                </div>
                <div v-else style="width: 150px;height:150px;line-height: 165px;">
                  <Icon type="ios-add-circle-outline" size="30" style="color:#6096FF" />
                </div>
              </Upload>
              <div class="photo_tip">{{$t('photo_tip')+" 280*280"}}</div>
            </FormItem>
            <FormItem :label="$t('status')" prop="status">
              <i-Switch size="large" v-model="form.status" true-value="1" false-value="0" />
            </FormItem>
          </div>
        </Form>
      </div>
      <div slot="footer">
        <Button @click="cancel()">{{ $t("cancel") }}</Button>
        <Button type="primary" @click="submit('form')">{{ $t("sure") }}</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  props: {
    modal: {
      type: Boolean,
      default: false,
    },
    itemObj: Object,
    type: String,
    roleList: Array
  },
  data () {
    const validateImg = (rule, value, callback) => {
      if (value == '') {
        callback(new Error(this.$t('p_upload_img')));
      } else {
        callback();
      }
    };
    return {
      tabs: '1',
      form: {
        role_id: null,
        sort_id: null,
        en_cname: "",
        en_cdesc: "",
        "zh-cn_cname": "",
        "zh-cn_cdesc": "",
        "zh-tw_cdesc": "",
        "zh-tw_cname": "",
        reg_image: "",
        role: null,
        status: "0",
      },
      ruleInline: {
        'zh-cn_cname': [
          {
            required: true,
            message: this.$t("Role.cname_input"),
            trigger: "blur"
          }
        ],
        'zh-tw_cname': [
          {
            required: true,
            message: this.$t("Role.cname_input"),
            trigger: "blur"
          }
        ],
        en_cname: [
          {
            required: true,
            message: this.$t("Role.cname_input"),
            trigger: "blur"
          }
        ],
        sort_id: [
          {
            type: 'number',
            required: true,
            message: this.$t('sort_input'),
            trigger: 'blur'
          }
        ],
        role: [
          {
            required: true,
            message: this.$t('select_role'),
            trigger: 'change'
          }
        ],
        reg_image: [
          {
            required: true,
            trigger: 'change',
            validator: validateImg
          }
        ],
        status: [
          {
            required: true,
            message: ' ',
            trigger: "blur"
          }
        ],
      },
      show: this.modal,

    }

  },
  created () {
    this.info()
  },
  mounted () {

  },
  methods: {
    info () {
      if (this.type != 'add') {
        this.form = {
          role_id: this.itemObj.role_id,
          sort_id: this.itemObj.sort_id * 1,
          en_cname: this.itemObj.en_cname,
          en_cdesc: "",
          "zh-cn_cname": this.itemObj['zh-cn_cname'],
          "zh-cn_cdesc": "",
          "zh-tw_cdesc": "",
          "zh-tw_cname": this.itemObj['zh-tw_cname'],
          reg_image: this.itemObj.reg_image,
          role: this.itemObj.role,
          status: this.itemObj.status
        }
      }
    },
    cancel () {
      this.$emit('cancel');
    },
    error () {
      this.$Message.error(this.$t("improve_information"));
    },
    ontabs (item) {
      this.tabs = item
    },
    handleBeforeUpload (file) {
      this.$base.showLoading();
      this.$base.uploadPicimg(file, '').then(res => {
        this.$base.hideLoading();
        if (res.url) {
          this.form.reg_image = res.url
        }
      });
    },
    submit (name) {
      if (this.form['zh-cn_cname'] == '') {
        this.tabs = '1'
      } else if (this.form['zh-tw_cname'] == '') {
        this.tabs = '2'
      } else if (this.form.en_cname == '') {
        this.tabs = '3'
      }
      this.$refs[name].validate(valid => {
        if (valid) {
          this.$base.showLoading();
          this.$request.sendPost(
            this.type == 'add' ? 'edu-role/add' : 'edu-role/upd',
            this.form,
            (success, data, error) => {
              this.$base.hideLoading();
              if (!success) return this.$base.alertErr(error.errmsg);
              this.cancel()
              this.$emit('onOk');
            }
          );
        } else {
          this.error()
        }
      });
    },
  }
}
</script>

<style lang="less" scoped>
/deep/ .modal {
  .ivu-tabs .ivu-tabs-tabpane {
    margin-top: 40px;
  }
  .item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 80%;
    margin: 0 0 20px 10%;
  }
  .tabs_item {
    width: 80%;
    margin: 20px 0 0 10%;
    .item_input {
      width: 100%;
      padding-right: 10px;
    }
  }
  .ivu-tabs-nav-scroll {
    display: flex;
    justify-content: center;
  }
  .demo-upload-list {
    display: inline-block;
    width: 150px;
    height: 150px;
    text-align: center;
    line-height: 100px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    margin-right: 4px;
  }
  .demo-upload-list img {
    width: 100%;
    height: 100%;
    border: 1px solid #dcdee2;
  }
  .ivu-upload-drag {
    height: 150px;
  }
  .photo_tip{
      color: #c5c8ce;
      font-size: 13px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/edu/role/module/role_edit.vue